module.exports = __webpack_public_path__ + "media/images/card_backgrounds/associate_degree-fcde4df7aa929d263c3e356a27825ef8.png";